import { Link } from "react-router-dom";
import { Linkedin, Phone, MapPin, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SITE } from "../../content/site";
import { SOLUTIONS_DISCLAIMER, SOLUTIONS } from "../../content/solutions";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#082619] text-[#F9F8F3] grain" data-testid="site-footer">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-10 pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo tone="light" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#B4C7BA]">
            Renewable Energy Advisory | Solar Procurement Advisory | Solar Solutions. Connecting C&I consumers, developers and EPC partners across India.
          </p>
          <Link to="/contact" data-testid="footer-cta-enquire" className="mt-8 inline-flex rounded-full bg-[#74DC26] px-6 py-3 text-sm font-semibold text-[#082619] transition-colors hover:bg-white">
            Discuss Your Energy Requirements
          </Link>
        </div>
        <div className="lg:col-span-2">
          <p className="eyebrow text-[#74DC26]">Explore</p>
          <ul className="mt-5 space-y-3">
            {[{ id: "home", label: "Home", to: "/" }, ...NAV, { id: "contact", label: "Contact Us", to: "/contact" }].map((n) => (
              <li key={n.id}>
                <Link to={n.to} className="link-underline text-sm text-[#F9F8F3]/90" data-testid={`footer-link-${n.id}`}>{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow text-[#74DC26]">Solar Solutions</p>
          <ul className="mt-5 space-y-3">
            {SOLUTIONS.map((s) => (
              <li key={s.id}>
                <Link to={`/solutions#${s.id}`} className="link-underline text-sm text-[#F9F8F3]/90" data-testid={`footer-solution-${s.id}`}>{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow text-[#74DC26]">Contact</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex gap-3 text-[#F9F8F3]/90"><MapPin className="h-4 w-4 mt-0.5 text-[#74DC26]" />{SITE.location}</li>
            <li><a href={SITE.phoneHref} className="flex gap-3 text-[#F9F8F3]/90 hover:text-[#74DC26]" data-testid="footer-phone"><Phone className="h-4 w-4 mt-0.5 text-[#74DC26]" />{SITE.phone}</a></li>
            {SITE.email && <li><a href={`mailto:${SITE.email}`} className="flex gap-3 text-[#F9F8F3]/90 hover:text-[#74DC26]" data-testid="footer-email"><Mail className="h-4 w-4 mt-0.5 text-[#74DC26]" />{SITE.email}</a></li>}
            <li><a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="flex gap-3 text-[#F9F8F3]/90 hover:text-[#74DC26]" data-testid="footer-linkedin"><Linkedin className="h-4 w-4 mt-0.5 text-[#74DC26]" />LinkedIn</a></li>
          </ul>
        </div>
      </div>
      <p className="font-display mt-20 select-none text-[24vw] leading-[0.8] font-extrabold tracking-tighter text-[#0f3a26]" aria-hidden="true">
        Solitaire
      </p>
      <div className="mt-8 grid gap-6 border-t border-white/10 pt-8 text-xs leading-relaxed text-[#B4C7BA] md:grid-cols-2">
        <p>{SOLUTIONS_DISCLAIMER}</p>
        <p className="md:text-right">© {new Date().getFullYear()} Solitaire India. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
